import { Injectable } from '@angular/core';
import {
  AngularFirestore,
  AngularFirestoreDocument,
} from '@angular/fire/firestore';
import { Transaction } from '../../../model/transaction';
import { AuthenticationService } from 'src/app/auth/fire-auth/authentication.service';

@Injectable({
  providedIn: 'root',
})
export class TransactionsStoreService {
  constructor(
    private angularFireStore: AngularFirestore,
    private authenticationService: AuthenticationService
  ) {}

  private getUser() {
    return this.authenticationService.currentUserId;
  }

  public getTransactionsFromEveryOne() {
    return this.angularFireStore.collection(`transactions`).valueChanges();
  }

  addTransaction(transaction: Transaction) {
    return this.angularFireStore.collection(`transactions`).add(transaction);
  }

  addTransactions(transactions: Transaction[]) {
    const batch = this.angularFireStore.firestore.batch();

    transactions.forEach((transaction) => {
      const id = this.angularFireStore.createId();
      const docRef: any = this.angularFireStore
        .collection(`transactions`)
        .doc(id);
      batch.set(docRef.ref, transaction);
    });
    return batch.commit();
  }

  getTransaction(id) {
    return this.angularFireStore
      .collection(`transactions`)
      .doc(id)
      .snapshotChanges();
  }

  getAllTransactions() {
    return this.angularFireStore
      .collection(`transactions`, (ref) =>
        ref.where('owner', '==', this.getUser())
      )
      .valueChanges({ idField: 'id' });
  }

  updateTransaction(transaction: Transaction) {
    const id = transaction.id;
    delete transaction.id;
    return this.angularFireStore
      .collection(`transactions`)
      .doc(id)
      .set(transaction);
  }

  updateTransactions(transactions: Transaction[]) {
    const batch = this.angularFireStore.firestore.batch();
    transactions.forEach((transaction) => {
      const id = transaction.id;
      delete transaction.id;
      const docRef: any = this.angularFireStore
        .collection(`transactions`)
        .doc(id);
      batch.set(docRef.ref, transaction);
    });
    return batch.commit();
  }

  deleteTransaction(transaction) {
    return this.angularFireStore.doc(`transactions/${transaction.id}`).delete();
  }

  deleteTransactions(transactions: Transaction[]) {
    const batch = this.angularFireStore.firestore.batch();
    transactions.forEach((transaction) => {
      const id = transaction.id;
      delete transaction.id;
      const docRef: any = this.angularFireStore
        .collection(`transactions`)
        .doc(id);
      batch.delete(docRef.ref);
    });
    return batch.commit();
  }
}
